module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-rollo.607556dc.jpg";